/**
 * Event Highlights Slider
 * - Hides an .ehs section if it contains no images.
 * - Drives the custom scrollbar fill for each .ehs section.
 * - Adds click-and-drag scrolling on the slider (mouse; touch already
 *   scrolls natively via overflow-x).
 * - Each section is initialized independently; an error in one
 *   section can never affect another section or the rest of the page.
 */
(function () {
  function initSection(root) {
    try {
      if (root.dataset.ehsInit === 'true') return; // avoid double-init
      root.dataset.ehsInit = 'true';

      var slider = root.querySelector('.ehs__slider');
      if (!slider) return;

      // Hide only THIS section if no images actually rendered into it.
      if (slider.querySelectorAll('img').length === 0) {
        root.style.display = 'none';
        return;
      }

      var fill = root.querySelector('.ehs__scrollbar-fill');
      var track = root.querySelector('.ehs__scrollbar-track');

      function updateFill() {
        if (!fill || !track) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        var visibleRatio = Math.min(1, slider.clientWidth / slider.scrollWidth);
        var fillWidth = Math.max(visibleRatio * 100, 8);

        if (maxScroll <= 0) {
          fill.style.width = '100%';
          fill.style.transform = 'translateX(0)';
          return;
        }

        var progress = slider.scrollLeft / maxScroll;
        var trackWidth = track.clientWidth;
        var fillPx = (fillWidth / 100) * trackWidth;
        var maxTranslate = trackWidth - fillPx;

        fill.style.width = fillWidth + '%';
        fill.style.transform = 'translateX(' + (progress * maxTranslate) + 'px)';
      }

      slider.addEventListener('scroll', updateFill, { passive: true });
      window.addEventListener('resize', updateFill);
      updateFill();

      // --- Drag-to-scroll (mouse) ---
      var isDown = false;
      var didDrag = false;
      var startX = 0;
      var startScrollLeft = 0;

      function onPointerDown(e) {
        // Only left mouse button; let touch use native scrolling.
        if (e.pointerType === 'touch') return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;

        isDown = true;
        didDrag = false;
        startX = e.clientX;
        startScrollLeft = slider.scrollLeft;
        slider.classList.add('is-dragging');
        // Keep receiving move/up events even if the pointer leaves the slider.
        if (slider.setPointerCapture && e.pointerId != null) {
          try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }

      function onPointerMove(e) {
        if (!isDown) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 3) didDrag = true;
        slider.scrollLeft = startScrollLeft - delta;
      }

      function endDrag() {
        isDown = false;
        slider.classList.remove('is-dragging');
      }

      // Prevent a click firing on an image right after a drag.
      function onClickCapture(e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      }

      slider.addEventListener('pointerdown', onPointerDown);
      slider.addEventListener('pointermove', onPointerMove);
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);
      slider.addEventListener('pointerleave', endDrag);
      slider.addEventListener('click', onClickCapture, true);
    } catch (err) {
      // Fail silently within this section only — never throw to the rest of the page.
      if (window.console && console.error) {
        console.error('Event Highlights Slider (single section) error:', err);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.ehs').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init if a section is added/re-rendered later (e.g. theme editor).
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.ehs');
    if (root) initSection(root);
  });
})();